import { action, observable, computed } from 'mobx';

import config from 'config';
import Cookies from 'utils/cookies-helper';
import HttpClient from 'utils/httpclient';

const layoutDefault = {
  sidebar: false,
  sidebarIcons: false,
  heading: false,
  sidebarSubIcons: false,
  sidebarSub: false,
  sidebarFilters: false,
};

class AppStore {
  @observable sites = [];
  @observable site;
  @observable layout = layoutDefault;

  constructor() {
    const currentSite = localStorage.getItem('site');
    this.site = currentSite ? JSON.parse(currentSite) : null;
    const cookieSiteId = Cookies.getSiteId();
    this.cookieSiteId = cookieSiteId && (!this.site || this.site.id !== cookieSiteId) ? cookieSiteId : null;
    if (this.cookieSiteId) {
      this.site = { id: this.cookieSiteId }
    }
  }

  @action
  getFields() {
    return HttpClient.get(`${config.api}/getFields`)
      .then(action(response => response.data));
  }

  @action
  listSites() {
    return HttpClient.get(`${config.api}/sites/all`).then(response => {
      this.sites = response.data;

      // If the current selected site not contains in sites id array, delete from local storage
      const siteIds = this.sites.map(site => site.id)
      if (this.site && siteIds.indexOf(this.site.id) >= 0) {
        const pos = siteIds.indexOf(this.site.id);
        this.site = this.sites[pos]; // Update current selected site
        this.setSite(this.site)
      } else {
        this.site = null;
        localStorage.removeItem('site');
      }

      if (this.sites && this.cookieSiteId) {
        const site = this.sites.find(site => site.id == this.cookieSiteId)
        site && this.setSite(site)
        this.cookieSiteId = null
      }

      // If exist only one site, select them
      if (this.sites && this.sites.length === 1) {
        this.setSite(this.sites[0]);
      }

      return response.data;
    })
  }

  @action
  setSite(site) {
    this.site = site;
    localStorage.setItem('site', JSON.stringify(site));
    Cookies.setSiteId(site.id)
  }

  async setSiteById(siteId) {
    if (!this.sites.length) {
      await this.listSites()
    }

    const site = this.sites.find(site => site.id == siteId)
    if (!site) {
      return false;
    }

    this.setSite(site)
    return true
  }

  @action
  setLayout(key, value) {
    this.layout[key] = value;
  }

  @action
  resetLayout() {
    this.layout = layoutDefault;
  }

  @computed
  get hasSites() {
    return this.sites && this.sites.length > 0;
  }

  @computed
  get currentSiteID() {
    return this.site ? this.site.id : null;
  }

  @computed
  get getLayout() {
    return this.layout
  }

  get usertimezone() {
    return localStorage.session && JSON.parse(localStorage.session).organization.timeZone
  }

  get timezone() {
    return this.site && this.site.organization && this.site.organization.timeZone || this.usertimezone
  }
}

export default new AppStore();
